<template>
  <div>
    <div class="page-container">
      <div class="titie">MSDS查看详细</div>
      <div v-for="item in infoData">
        <div class="detail">
            <div class="left">{{item.k}}</div>
            <div class="right"  v-html='item.v'></div>
        </div>
      </div>
      <div class="line" style="margin-top: 20px"></div>
      <el-button plain @click="back">返回</el-button>

    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Table from 'components/Table'
import findMSDS from 'api/Management/findMSDS.js'
const _findMSDS = new findMSDS()
export default {
    data() {
        return {
          infoData:[],

        }
    },
    mounted(){
        this.getMSDSList()
    },
    methods:{
        getMSDSList(){
            if(this.$route.params.chemid){
              _findMSDS.msdsInfo(this.$route.params.chemid).then(res => {
                this.infoData =  JSON.parse(res.KV);

              })
            }

        },
      back() {
        this.$router.back()
      },


    },
    components: {
        Table,
        // Form
    }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .titie {
    width 100%
    height 30px
    line-height 30px
    font-size:20px;
    font-family:SimSun;
    font-weight:bold;
    color:#222
    text-align center
  }
  .detail {
    width 100%
    height auto
    overflow hidden
  }
  .left {
    width 100%
    line-height 30px
    color: #222;
    font-size: 15px;
    font-weight: bold;
  }
  .right {
    width 100%
    line-height 30px
    color #666
    font-size 14px
  }
</style>
